import React, { memo } from "react";
import { X } from "lucide-react";
import { AddMedicationWizard } from "../../AddMedicationWizard";
import MedicationIcon from "../../MedicationIcon";
import { useViewPerformance } from "@/hooks/useViewPerformance";

interface ManualEntryCardProps {
  toggleSection: () => void;
  isExpanded?: boolean;
}

export const ManualEntryCard: React.FC<ManualEntryCardProps> = memo(({
  toggleSection,
}) => {
  const { measureOperation } = useViewPerformance("ManualEntryCard");
  return (
    <div className="w-full h-full flex flex-col bg-white">
      <div
        className="p-4 flex items-start gap-4 border-b bg-white"
      >
        <div className="h-10 w-10 rounded-full bg-violet-600 flex items-center justify-center shrink-0">
          <MedicationIcon type="manual" className="text-white" />
        </div>
        <div className="flex-1">
          <h3 className="text-base font-semibold text-gray-900">
            Add medications in less than 2 mins
          </h3>
          <p className="text-gray-500 text-sm">
            Enter medication details using a simple step-by-step form
          </p>
        </div>
        <button 
          onClick={toggleSection}
          className="p-2 rounded-full hover:bg-gray-100 min-h-[48px] min-w-[48px] flex items-center justify-center"
          aria-label="Close panel"
        >
          <X className="h-5 w-5 text-gray-400" />
        </button>
      </div>

      <div className="flex-1 overflow-auto">
        <div className="p-4">
          <AddMedicationWizard isInTab={true} />
        </div>
      </div>
    </div>
  );
});
